import { Target } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import AchievementBadge from "@/components/badges/AchievementBadge";

export default function NextBadgeGoal({ nextBadge, categories }) {
  if (!nextBadge?.code) return null;

  const progress = nextBadge.progress || {};
  const remaining = Math.max(0, (progress.target || 0) - (progress.current || 0));

  return (
    <Card className="border-blue-100 bg-gradient-to-br from-blue-50/80 to-white" data-testid="next-badge-goal">
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-3">
          <Target className="w-4 h-4 text-blue-600" />
          <p className="text-xs font-bold uppercase tracking-wider text-blue-600">Prochain badge</p>
        </div>
        <div className="flex flex-wrap items-center gap-6">
          <AchievementBadge
            title={nextBadge.title}
            description={nextBadge.description}
            icon={nextBadge.icon}
            category={nextBadge.category}
            categories={categories}
            earned={false}
            progress={progress}
            size="md"
          />
          <div className="flex-1 min-w-[180px]">
            <div className="h-2.5 bg-white rounded-full overflow-hidden border border-blue-100">
              <div className="h-full bg-blue-500 rounded-full transition-all" style={{ width: `${progress.percent || 0}%` }} />
            </div>
            <p className="text-sm font-medium text-slate-700 mt-2">
              {remaining > 0
                ? `Plus que ${remaining} pour « ${nextBadge.title} »`
                : `Presque : ${nextBadge.title}`}
            </p>
            <p className="text-xs text-slate-400 mt-1">{progress.current ?? 0} / {progress.target ?? 1}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}